import { KYB_STATUSES } from '@/shared/constants/store-constants/account'

export default {
  requisites: (state) => state.requisites,
  isLoading: (state) => state.isLoading,
  isLoaded: (state) => state.isLoaded,

  kybStatus: (state) => state.kybStatus,
  kybStatusUpdatedAt: (state) => state.kybStatusUpdatedAt,
  isKybStatusLoading: (state) => state.isKybStatusLoading,
  isKybStatusLoaded: (state) => state.isKybStatusLoaded,

  isKybNotStarted: (state) =>
    state.kybStatus === KYB_STATUSES.NOT_STARTED ||
    state.kybStatus === KYB_STATUSES.UNSPECIFIED,
  isKybInProgress: (state) => state.kybStatus === KYB_STATUSES.IN_PROGRESS,
  isKybApproved: (state) => state.kybStatus === KYB_STATUSES.APPROVED,
  isKybDeclined: (state) => state.kybStatus === KYB_STATUSES.DECLINED,
}
